import React from 'react';
import { twMerge } from 'tailwind-merge';

interface TimesheetProps {
  className?: string;
  width?: number;
  height?: number;
}

const TimesheetIcon = function TimesheetIcon({
  className,
  width,
  height,
}: TimesheetProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <g clipPath="url(#clip0_1212_10083)">
        <path d="M11.3335 16.668L20.6668 16.668" stroke="#4D586A" strokeLinecap="round" />
        <path d="M11.3335 20.668L16.6668 20.668" stroke="#4D586A" strokeLinecap="round" />
        <path className={twMerge(className, 'fill-white')} d="M7.3335 7.06797C7.3335 6.22789 7.3335 5.80785 7.49699 5.48698C7.6408 5.20474 7.87027 4.97527 8.15251 4.83146C8.47338 4.66797 8.89342 4.66797 9.7335 4.66797H17.006C17.3729 4.66797 17.5564 4.66797 17.729 4.70941C17.8821 4.74616 18.0284 4.80677 18.1626 4.88901C18.314 4.98177 18.4437 5.11148 18.7031 5.37091L23.9639 10.6317C24.2233 10.8911 24.353 11.0208 24.4458 11.1722C24.528 11.3064 24.5886 11.4527 24.6254 11.6058C24.6668 11.7784 24.6668 11.9619 24.6668 12.3287V24.9346C24.6668 25.7747 24.6668 26.1948 24.5033 26.5156C24.3595 26.7979 24.1301 27.0273 23.8478 27.1711C23.5269 27.3346 23.1069 27.3346 22.2668 27.3346H9.7335C8.89342 27.3346 8.47338 27.3346 8.15251 27.1711C7.87027 27.0273 7.6408 26.7979 7.49699 26.5156C7.3335 26.1948 7.3335 25.7747 7.3335 24.9346V7.06797Z" stroke="#4D586A" />
        <path className={twMerge(className, 'fill-white')} d="M16.6665 4.66797V10.268C16.6665 11.108 16.6665 11.5281 16.83 11.849C16.9738 12.1312 17.2033 12.3607 17.4855 12.5045C17.8064 12.668 18.2264 12.668 19.0665 12.668H24.6665" stroke="#4D586A" />
        <circle cx="21.0002" cy="21.9987" r="7.16667" fill="white" stroke="#4D586A" />
        <path d="M24.75 21.9987H21.25C21.1119 21.9987 21 21.8868 21 21.7487V19.082" stroke="#4D586A" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_1212_10083">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

TimesheetIcon.defaultProps = {
  className: '',
  width: 32,
  height: 32,
};

export default TimesheetIcon;
